import BottomSheet from "../BottomSheet/BottomSheet";
import { FaTools, FaCheckCircle } from "react-icons/fa";
import styles from "./ServiceLimitCarBottomSheet.module.css";

const ServiceLimitCarBottomSheet = ({

    open,

    onClose,

    carTitle = "",

}) => {

    return (

        <BottomSheet

            open={open}

            onClose={onClose}

        >

            <div className={styles.container}>

                <div className={styles.iconWrapper}>

                    <FaTools />

                </div>

                <h3 className={styles.title}>

                    حداکثر تعداد خودرو ثبت شده

                </h3>

                {/* {

                    carTitle && (

                        <p className={styles.carTitle}>

                            خودرو:

                            <strong>

                                {" "}

                                {carTitle}

                            </strong>

                        </p>

                    )

                } */}

                <p className={styles.description}>

                    برای هر کاربر حداکثر

                    <strong>

                        {" "}5 خودرو{" "}

                    </strong>

                    قابل ثبت است.

                </p>

                <div className={styles.note}>

                    <div>

                        • در صورت نیاز یکی از خودروهای خود را حذف کنید.

                    </div>

                </div>

                <button

                    type="button"

                    className={styles.button}

                    onClick={onClose}

                >

                    <FaCheckCircle />

                    <span>

                        متوجه شدم

                    </span>

                </button>

            </div>

        </BottomSheet>

    );

};

export default ServiceLimitCarBottomSheet;